<ppl-loading-overlay [loading]="!data.hideLoading"
                     [inverse]="true"
                     [large]="true"
                     [text]="text$ | async"></ppl-loading-overlay>
